import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import courses from './courses';
import orders from './orders';

export const resources = {
  'pt-BR': {
    courses,
    orders
  }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    resources,
    lng: "pt-BR", // if you're using a language detector, do not define the lng option
    fallbackLng: "pt-BR",
    debug: true,
    interpolation: {
      skipOnVariables: false,
      escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    }
  });

i18n.services.formatter?.add('hideCreditCard', value => value.slice(-4));
